
import { get, post, getBaseUrl,getAuthToken } from './http'

/*获取用户认证token*/
export const authToken = () => getAuthToken();

/*登录接口*/
export const loginAddress = param => post('/book/login/doLogin', param);


/*注册接口*/
export const registerAddress = param => post('/book/login/doRegister', param);
export const getExpScoreList = param => post('/book/user/getExpScoreList', param);
export const addExpScore = param => post('/book/user/addExpScore', param);

/** 公共文件上传 */
/*封面图片上传地址*/
export const uploadImgUrl = () => getBaseUrl('/book/file/uploadCoverImg');

/*pdf文件上传地址*/
export const uploadPdfUrl = () => getBaseUrl('/book/file/uploadPdfBook');

/*文件下载地址*/
export const getDownloadUrl = () => getBaseUrl('/book/file/download');

/** 用户相关 */
/*首页统计信息接口*/
export const syVisitInfo = param => get('/book/sy/getStaInfo', param);

/*获取用户列表接口*/
export const getUserList = param => post('/book/user/getUserList', param);

/*获取用户信息接口*/
export const getUserInfo = param => get('/book/user/getUserInfo', param);

/*修改用户信息接口*/
export const updateUser = param => get('/book/user/updateUser', param);

/*删除用户接口*/
export const delUser = param => post('/book/user/delUser', param);

/** 电子书 */
/*分页查询电子书列表*/
export const qryEbookList = param => post('/book/eBook/qryEbookInfoList', param);

/*查询所有电子书*/
export const qryAllEbookList = param => post('/book/eBook/qryAllEbookInfoList', param);

/*提交推荐的电子书*/
export const updateSubEbookList = param => post('/book/eBook/updateSubEbookList', param);

/*查询推荐的电子书*/
export const qrySubEbookInfoList = param => post('/book/eBook/qrySubEbookInfoList', param);

/*查询电子书详情*/
export const qryEbookInfoById = param => post('/book/eBook/queryEBookInfo', param);

/*更新电子书*/
export const updateEBookInfo = param => post('/book/eBook/updateEBookInfo', param);

/*删除电子书*/
export const delEBookInfo = param => post('/book/eBook/deleteBookInfo', param);

/*查询电子书分类列表*/
export const qryEbookTypeList = param => post('/book/eBook/qryEbookTypeInfoList', param);

/*更新电子书分类*/
export const updateEBookTypeInfo = param => post('/book/eBook/updateEBookTypeInfo', param);

/*删除电子书分类*/
export const delEBookTypeInfo = param => post('/book/eBook/deleteBookTypeInfo', param);

/** 视频 */
/*查询视频列表*/
export const qryVideoList = param => post('/book/video/qryVideoInfoList', param);

/*查询视频详情*/
export const qryVideoInfoById = param => post('/book/video/queryVideoInfo', param);

/*更新视频*/
export const updateVideoInfo = param => post('/book/video/updateVideoInfo', param);

/*删除视频*/
export const delVideoInfo = param => post('/book/video/deleteVideoInfo', param);

/*查询视频分类列表*/
export const qryVideoTypeList = param => post('/book/video/qryVideoTypeInfoList', param);

/*更新视频分类*/
export const updateVideoTypeInfo = param => post('/book/video/updateVideoTypeInfo', param);

/*删除视频分类*/
export const delVideoTypeInfo = param => post('/book/video/deleteVideoTypeInfo', param);

/*查询所有电子书*/
export const qryAllVideoList = param => post('/book/video/qryAllVideoList', param);

/*提交推荐的电子书*/
export const updateSubVideoList = param => post('/book/video/updateSubVideoList', param);

/*查询推荐的电子书*/
export const qrySubVideoInfoList = param => post('/book/video/qrySubVideoInfoList', param);


/*获取关于我们信息*/
export const getSettingInfo = param => post('/book/setting/getSettingMsg', param);

/*修改关于我们信息*/
export const updateSettingInfo = param => post('/book/setting/updateSettingMsg', param);



/** 论文 */
/*查询论文列表*/
export const qryPaperList = param => post('/book/paper/qryPaperInfoList', param);

/*查询论文详情*/
export const qryPaperInfoById = param => post('/book/paper/queryPaperInfo', param);

/*更新论文*/
export const updatePaperInfo = param => post('/book/paper/updatePaperInfo', param);

/*删除论文*/
export const delPaperInfo = param => post('/book/paper/deletePaperInfo', param);

/*查询论文分类列表*/
export const qryPaperTypeList = param => post('/book/paper/qryPaperTypeInfoList', param);

/*更新论文分类*/
export const updatePaperTypeInfo = param => post('/book/paper/updatePaperTypeInfo', param);

/*删除论文分类*/
export const delPaperTypeInfo = param => post('/book/paper/deletePaperTypeInfo', param);


/** 首页 */
/*首页bar*/
export const getBarList = param => get('/book/sy/getBarList', param);

/*资源推荐*/
export const getSpecialResourceList = param => get('/book/sy/getSpecialResourceList', param);

/*查询推荐的电子书*/
export const qrySubEbookList = param => post('/book/sy/qrySubEbookList', param);

/*查询推荐的视频*/
export const qrySubVideoList = param => post('/book/sy/qrySubVideoList', param);




// WEBPACK FOOTER //
// ./src/request/api.js